<template>
    <div v-if="Object.keys(event).length > 0" style="margin-bottom: 75px;">
        <!-- Header image for event location -->
        <div class="event-page-header">
            <!-- <el-carousel class="event-page-carousel" :interval="6000" indicator-position="none" height="100%" style="z-index: 0;">
                <el-carousel-item v-for="(item,index) in getImages" :key="index">
                    <div class="carousel-image" :style="backgroundImageStyle(item.image)"></div>
                </el-carousel-item>
            </el-carousel> -->
            <lory class="event-page-carousel"
                  :options="{ slideSpeed: 1600, enableMouseEvents: true, infinite: 1, interval: 4000 }">
                <item class="carousel-image" v-for="(item, index) in getImages" :key="index" style="width: 100%;">
                    <div :style="backgroundImageStyle(item.image)"></div>
                </item>
            </lory>
            <div class="event-page-header-gradient" style="z-index: 1;">
                <div class="event-page-buttons-top-left event-header__buttons" style="z-index: 2;">
                    <div v-if="isHost || isAttending" class="event-page__mobile__top-info-bar-padding"></div>
                    <button
                        style="width: 40px; text-align: left"
                        type="button"
                        class="btn-flat-icon--light"
                        @click="goBack"
                    >
                        <v-icon large>fal fa-chevron-left</v-icon>
                    </button>
                </div>
                <div class="event-page-buttons-top-right event-header__buttons">
                    <div v-if="isHost || isAttending" class="event-page__mobile__top-info-bar-padding"></div>
                    <button
                        type="button"
                        class="btn-flat-icon--light ml-3"
                        @click="favoriteEvent(event)"
                    >
                        <v-icon large>{{ likedEvent }}</v-icon>
                    </button>
                    <button
                        type="button"
                        class="btn-flat-icon--light ml-3"
                        v-if="event.approved"
                        @click="shareModalOpen=true"
                    >
                        <v-icon large>fal fa-share-alt</v-icon>
                    </button>
                </div>
                <div class="event-page-header-bottom-left text-xs-left">
                    <v-layout row wrap class="pl-4" style="padding-right: 36px;">
                        <v-flex xs7 sm8 offset-sm1 md6 offset-md1 lg5 offset-lg2 xl5 offset-xl3>
                            <p class="event-page-header-category mb-1">
                                {{ event.category }}
                            </p>
                            <p class="event-page-header-location ma-0 mb-1">
                                <span style="font-size: .70em">@</span>
                                <span style="font-size: .95em"><i>{{ event.location.name }}</i></span>
                            </p>
                            <p class="event-page-category-logline mb-2">{{ event.subtitle }}</p>
                        </v-flex>
                    </v-layout>
                </div>
            </div>
        </div>
        <v-layout row wrap class="event-page-body">
            <v-flex xs12>
                <v-layout row wrap class="pa-4">
                    <div style="position: absolute; top: 0; right: 10%; margin-top: -50px;">
                        <div class="event-page-header-circle text-xs-center hidden-md-and-up">
                            <v-avatar :size="mapSizeOuter" class="white event-page-circle-outer">
                                <v-avatar :size="mapSizeInner" class="date-icon event-page-circle-inner">
                                    <div class="event-page-header-date-weekday mt-1">{{ weekday }}</div>
                                    <div class="event-page-header-date-month">{{ eventMonth }}</div>
                                    <div class="event-page-header-date-day mb-0">{{ eventDay }}</div>
                                </v-avatar>
                            </v-avatar>
                        </div>
                    </div>
                    <v-flex xs12 sm10 offset-sm1 md6 offset-md1 lg5 offset-lg2 xl4 offset-xl3>
                        <v-layout row wrap class="event-page__detail-list-margin">
                            <v-flex xs8 offset-xs2 v-if="!event.approved" class="mt-5">
                                <h3 class="red--text text-xs-center mb-2">This Event is not public!</h3>
                                <h4 class="red--text text-xs-center mb-4">All events must first be approved by the
                                    wrkprty staff before going live.</h4>
                            </v-flex>
                            <v-flex xs8 offset-xs2 v-if="getApprovalStatus" class="mt-5 hidden-md-and-up">
                                <h3 class="red--text text-xs-center mb-2">{{ getApprovalStatus }}</h3>
                            </v-flex>
                            <v-flex xs8 offset-xs2
                                    v-if="requiresApproval && !isAttending && !isHost && !getApprovalStatus"
                                    class="mt-5">
                                <h3 class="red--text text-xs-center mb-2">This event requires the host to approve all
                                    guests before they can attend. Please RSVP to put yourself on the waitlist. You
                                    won't be charged until you are approved.</h3>
                            </v-flex>
                            <v-flex sm8 offset-sm1 xs-8 class="event-page-details-table hidden-md-and-up mt-1">
                                <div class="event-page-details-flex">
                                    <div class="details-icon" style="width: 50px;">
                                        <i style="font-size: 1.55em;" class="success--text fal fa-map-marker"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content ma-0" style="width: 58%;">
                                            {{ locationShort }}</p>
                                    </div>
                                </div>
                                <div class="event-page-details-flex">
                                    <div class="details-icon" style="width: 50px;">
                                        <i style="font-size:1.55em;" class="link--text fal fa-clock"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content ma-0">{{ eventTime }}</p>
                                    </div>
                                </div>
                                <div class="event-page-details-flex">
                                    <div class="details-icon" style="width: 50px;">
                                        <i style="font-size:1.55em;" class="link--text fal fa-clock"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content ma-0">{{ weekday }},
                                            {{ eventDateNumeric }}</p>
                                    </div>
                                </div>
                                <div class="event-page-details-flex">
                                    <div class="details-icon" style="width: 50px;">
                                        <i style="font-size:1.55em;" class="error--text fal fa-check-square"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content ma-0">
                                            <span>Open to </span>
                                            <span v-for="(r,index) in event.restrictions.provisions" :key="r">
												<span v-if="r === 'occupation_or_interest'">
													people interested in {{
                                                        event.restrictions.inputs[r + '_input']
                                                    }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
												</span>
												<span v-else-if="r === 'women_only'">
													women only<span
                                                    v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
												</span>
												<span v-else-if="r === 'parents_only'">
													parents with children {{ event.restrictions.inputs.min_child_age }} to {{
                                                        event.restrictions.inputs.max_child_age
                                                    }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
												</span>
												<span v-else-if="r === 'age_range'">
													people between the ages of {{ event.restrictions.inputs.min_age }} to {{
                                                        event.restrictions.inputs.max_age
                                                    }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
												</span>
												<span v-else>{{ r }}<span
                                                    v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span></span>
											</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="event-page-details-flex" v-if="eventAmenities.length !== 0">
                                    <div class="details-icon" style="width: 50px;">
                                        <i style="font-size:1.55em;" class="fal fa-coffee"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content ma-0">
											<span
                                                v-if="event.provisions.hasOwnProperty('amenitiesInputs') && event.provisions.amenitiesInputs.hasOwnProperty('other_snack_input')"
                                                style="text-transform: capitalize;"
                                            >
												{{ event.provisions.amenitiesInputs.other_snack_input }}, 
											</span>
                                            <span v-for="(p, index) in eventAmenities"
                                                  style="text-transform: capitalize;" :key="index">
												{{ p }}<span
                                                v-if="index == eventAmenities.length - 2">&nbsp;&amp;</span><span
                                                v-else-if="index < eventAmenities.length -1">,</span>
											</span>
                                            <!--<span>&nbsp;provided</span>-->
                                        </p>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>

                        <div class="hidden-md-and-up">
                            <div class="event-page-host-container">
                                <div class="host-divider">
                                </div>
                                <div class="white host-circle" @click="hostModal=true">
                                    <div :style="{'background-image': 'url(' + host.avatar + '?w=100)'}"
                                         class="host-image"></div>
                                </div>
                                <div v-if="event.cohosts.length > 0" class="white cohost-circle1"
                                     @click="openCohostModal(0)">
                                    <div :style="{'background-image': 'url(' + event.cohosts[0].user.avatar + '?w=75)'}"
                                         class="cohost-image1"></div>
                                </div>
                                <div v-if="event.cohosts.length > 1" class="white cohost-circle2"
                                     @click="openCohostModal(1)">
                                    <div :style="{'background-image': 'url(' + event.cohosts[1].user.avatar + '?w=75)'}"
                                         class="cohost-image2"></div>
                                </div>
                                <p class="host-name mb-0">
                                    Hosted by <a @click="hostModal=true"><b>{{ host.first_name }}</b></a><span
                                    v-if="event.cohosts.length > 0"><br>&amp;&nbsp;<a @click="openCohostModal(0)"
                                                                                      style="display: inline-block"><b>{{
                                        event.cohosts[0].user.first_name
                                    }}</b></a><span
                                    v-if="event.cohosts.length > 1">&nbsp;&amp;&nbsp;<a @click="openCohostModal(1)"
                                                                                        style="display: inline-block"><b>{{
                                        event.cohosts[1].user.first_name
                                    }}</b></a></span></span>
                                </p>
                            </div>
                            <div v-if="eventCategoryLongDescription !== ''">
                                <!--<p class="event-page-sub-heading">What to Expect</p>-->
                                <p class="event-page-content mt-n2 pb-2" v-html="eventCategoryLongDescription"></p>
                            </div>
                        </div>
                        <div class="hidden-sm-and-down">
                            <div v-if="eventCategoryLongDescription !== ''">
                                <!--<p class="event-page-sub-heading mt-4">What to Expect</p>-->
                                <br>
                                <p class="event-page-content mt-n2 pb-2" v-html="eventCategoryLongDescription"></p>
                            </div>
                            <div class="event-page-host-container">
                                <div class="host-divider">
                                </div>
                                <div class="white host-circle" @click="hostModal=true" style="cursor: pointer;">
                                    <div :style="{'background-image': 'url(' + host.avatar + '?w=100)'}"
                                         class="host-image"></div>
                                </div>
                                <div v-if="event.cohosts.length > 0" class="white cohost-circle1"
                                     @click="openCohostModal(0)" style="cursor: pointer;">
                                    <div :style="{'background-image': 'url(' + event.cohosts[0].user.avatar + '?w=75)'}"
                                         class="cohost-image1"></div>
                                </div>
                                <div v-if="event.cohosts.length > 1" class="white cohost-circle2"
                                     @click="openCohostModal(1)" style="cursor: pointer;">
                                    <div :style="{'background-image': 'url(' + event.cohosts[1].user.avatar + '?w=75)'}"
                                         class="cohost-image2"></div>
                                </div>
                                <p class="host-name mb-0">
                                    Hosted by <a @click="hostModal=true"><b>{{ host.first_name }}</b></a><span
                                    v-if="event.cohosts.length > 0"><br>&amp;&nbsp;<a @click="openCohostModal(0)"
                                                                                      style="display: inline-block"><b>{{
                                        event.cohosts[0].user.first_name
                                    }}</b></a><span
                                    v-if="event.cohosts.length > 1">&nbsp;&amp;&nbsp;<a @click="openCohostModal(1)"
                                                                                        style="display: inline-block"><b>{{
                                        event.cohosts[1].user.first_name
                                    }}</b></a></span></span>
                                </p>
                            </div>
                        </div>

                        <p class="event-page-sub-heading mt-0 mb-3">What To Expect</p>

                        <p class="event-page-content" v-html="newlines(event.description)"></p>

                        <div class="event-page-details-table ma-0 pa-0 mt-3">
                            <div style="color: #888;">
                                <div class="event-page-details-flex mb-1">
                                    <div class="details-icon pa-1" style="width: 50px;">
                                        <i style="font-size:1.55em; color: #CCC" class="fal fa-clock"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content-light ma-0">Duration:
                                            <b>{{ getDuration }}&nbsp;hours</b></p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="event.notes !== null && event.notes !== ''" class="mt-4">
                            <p class="event-page-sub-heading mt-5 mb-3">Host Notes</p>
                            <p class="event-page-content" v-html="newlines(event.notes)"></p>
                        </div>

                        <div class="event-page-details-table ma-0 pa-0 mt-3">
                            <div style="color: #888;">
                                <div class="event-page-details-flex mb-1" v-if="eventAmenities.length > 0">
                                    <div class="details-icon pa-1" style="width: 50px;">
                                        <i style="font-size:1.55em; color: #CCC" class="fal fa-coffee"></i>
                                    </div>
                                    <div class="content">
                                        <p class="event-page__detail-list-content-light ma-0">
                                            Provided by host:
                                            <span
                                                v-if="event.provisions.hasOwnProperty('amenitiesInputs') && event.provisions.amenitiesInputs.hasOwnProperty('other_snack_input')"
                                                style="text-transform: capitalize;"
                                            >
                                                {{ event.provisions.amenitiesInputs.other_snack_input }},
                                            </span>

                                            <span
                                                v-for="(p, index) in eventAmenities"

                                                style="text-transform: capitalize;"

                                                :key="index"
                                            >
                                                {{ p }}
                                                <span v-if="index == eventAmenities.length - 2">,</span>
                                                <span v-else-if="index < eventAmenities.length -1">,</span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div v-if="event.addons.length !== 0 && event.addons !== null && event.addons !== ''"
                             class="mt-5">
                            <div v-if="event.addons[0]">
                                <div v-if="event.addons[0].approved">

                                    <v-divider class=""></v-divider>


                                    <p class="event-page-sub-heading mt-4 mb-3">Optional Add-On


                                        <!--<span v-if="!userInAddon(user.pk) && !isHost" style="display: flex; justify-content: flex-start; align-items: center; position: relative;">
                                            <v-checkbox
                                                v-model="buyAddon"
                                                label="Add To Ticket"
                                                hide-details
                                            ></v-checkbox></span>-->

                                    </p>
                                    <p class="event-page-content" v-html="newlines(event.addons[0].description)"></p>


                                    <p class="event-page-content"
                                       style="font-weight: bold; display: flex; align-items: center;"
                                       v-if="userInAddon(user.pk)">You're signed up for this add-on&nbsp;&nbsp;<v-icon
                                        small class="success--text">fal fa-check
                                    </v-icon>
                                    </p>


                                    <div class="event-page-details-table ma-0 pa-0 mt-3">
                                        <div style="color: #888;">

                                            <div class="event-page-details-flex mb-1">
                                                <div class="details-icon pa-1" style="width: 50px;">
                                                    <i style="font-size:1.55em; color: #CCC" class="fal fa-clock"></i>
                                                </div>
                                                <div class="content">
                                                    <p class="event-page__detail-list-content-light ma-0">
                                                        {{ event.addons[0].title }}</p>
                                                </div>
                                            </div>

                                            <div class="event-page-details-flex mb-1">
                                                <div class="details-icon pa-1" style="width: 50px;">
                                                    <i style="font-size:1.55em; color: #CCC" class="fal fa-clock"></i>
                                                </div>
                                                <div class="content">
                                                    <p class="event-page__detail-list-content-light ma-0">
                                                        {{ event.addons[0].start_time }} to
                                                        {{ event.addons[0].end_time }}</p>
                                                </div>
                                            </div>


                                            <div class="event-page-details-flex mb-1">
                                                <div class="details-icon pa-1" style="width: 50px;">
                                                    <i style="font-size:1.55em; color: #CCC" class="fal fa-clock"></i>
                                                </div>
                                                <div class="content">
                                                    <p class="event-page__detail-list-content-light ma-0">
                                                        ${{ event.addons[0].price }}</p>
                                                </div>
                                            </div>


                                        </div>
                                    </div>


                                    <!--	<p class="event-page-content">Start Time: <span style="text-transform: capitalize;">{{event.addons[0].time_slot}}</span> event from {{event.addons[0].start_time}} to {{event.addons[0].end_time}}</p>-->


                                    <div class="event-page-sub-heading mt-0 mb-3"
                                         v-if="!userInAddon(user.pk) && !isHost">
                                        <v-checkbox style="font-size: .65em; color: #74cbf1;"
                                                    v-model="buyAddon"
                                                    label="Add To Ticket"
                                                    hide-details
                                        ></v-checkbox>
                                    </div>
                                </div>
                            </div>

                            <v-divider class="mt-4 mb-5"></v-divider>

                        </div>

                        <!-- <div class="event-page-location-container">
                            <v-divider class="location-divider"></v-divider>
                            <div :style="{'background-image': 'url(' + event.location.primary_image.image + ')'}" class="location-image"></div>
                            <p class="location-name mb-0">
                                About the location: <a @click="locationModal=true" style="font-size: 1.2em"><b>@{{location.name}}</b></a>
                            </p>
                        </div>

                        <img class="event-page-flat-logo" src="/static/images/wrkprty-flattened-logo.png" alt=""> -->


                        <!--		<p class="event-page-sub-heading mt-4 mb-3">About the Space </p> -->


                        <p class="event-page-sub-heading mt-5 mb-1">Location</p>

                        <p class="event-page-content">{{ locationShort }}</p>

                        <div class="event-page__map-container">
                            <div class="top-fade">
                                <!-- <div class="event-page__flag-background">
                                    <div class="event-page__flag" :style="{'background-image': 'url(' + event.location.primary_image.image + ')' }"></div>
                                </div> -->
                            </div>
                            <google-map
                                styleProp='{
									height: 300px,
									width: 100%,
								}'
                                :mapcenter='mapcenter'
                                :zoom='mapzoom'
                                :radius="350">
                            </google-map>
                        </div>

                        <!--			<div class="event-page-sub-heading mt-5 mb-3">
                                        <a @click="locationModal=true">{{event.location.name}}</a> / {{locationLong}}
                                    </div> -->

                        <div class="event-page-sub-heading mt-4 mb-3"><a
                            @click="locationModal=true">{{ event.location.name }}</a></div>

                        <p class="event-page-content" v-html="newlines(event.location.description)"></p>

                        <!-- <a class="event-page-sub-heading" style="margin-bottom: 24!important;" v-if="isAttending || isHost" target="_blank" :href="'https://www.google.com/maps/dir/?api=1&destination=' + getCoords">Directions</a> -->

                        <!-- <div v-if="getParkingInfo">
                            <p class="event-page-sub-heading-2">Parking info</p>
                            <v-divider class="mt-1 mb-3"></v-divider>
                            <p class="event-page__parking-info" v-html="newlines(getParkingInfo)">
                            </p>
                        </div> -->

                        <p class="event-page-sub-heading mt-5 mb-3">Space Amenities</p>

                        <choice-field-display class="amenities-header-2" :original="locationInfoOptions"
                                              :fields="event.provisions.provisions"
                                              :inputs="event.provisions.infoInputs"></choice-field-display>
                        <choice-field-display class="amenities-header-2" :original="eventProvisionsOptions"
                                              :fields="event.provisions.provisions"
                                              :inputs="event.provisions.infoInputs"></choice-field-display>


                        <div v-if="event.location_rules !== null && event.location_rules !== ''">
                            <v-divider class="mt-5 mb-3"></v-divider>


                            <p class="event-page-sub-heading mt-4 mb-3">House Rules</p>
                            <p class="event-page-content" v-html="newlines(event.location_rules)"></p>
                        </div>

                        <v-divider class="mt-4 mb-4"></v-divider>

                        <p class="event-page-sub-heading mt-3"><a @click="guestRequirementsModal=true">Guest
                            requirements</a></p>

                        <v-divider class="mt-4 mb-4"></v-divider>

                        <p class="event-page-sub-heading mt-3"><a @click="cancellationPolicyModal=true">Cancellation
                            policy &amp; terms</a></p>

                        <v-divider class="mt-4 mb-4"></v-divider>

                        <p class="event-page-sub-heading mt-3"><a @click="contactHostModal=true">Contact host</a></p>

                        <v-divider class="mt-4 mb-4"></v-divider>

                        <p class="event-page-sub-heading-small" style="margin-top: 100px;"><a
                            @click="reportEventModal=true">Report this location, event, or host</a></p>
                    </v-flex>

                    <!-- EVENT PAGE RSVP CARD -->
                    <v-flex md4 lg3 xl3 class="hidden-sm-and-down pl-5 ml-5 pr-2">
                        <v-card :class="{'event-page-rsvp-card': !isHost}">
                            <div style="display: inline-block; margin-bottom: -20px;">
                                <v-avatar :size="mapSizeOuter"
                                          class="white event-page-circle-outer event-page-desktop-date-circle-card">
                                    <v-avatar :size="mapSizeInner" class="date-icon event-page-circle-inner">
                                        <div class="event-page-header-date-weekday mb-0 mt-1">{{ weekday }}</div>
                                        <div class="event-page-header-date ma-0 mb-0">{{ eventMonth }}</div>
                                        <div class="event-page-header-date">{{ eventDay }}</div>
                                    </v-avatar>
                                </v-avatar>
                            </div>
                            <div class="event-page-card-sticky-note pl-2 pr-2 pb-2 text-xs-center"
                                 v-if="(showSpotsLeft && !isAttending && !isHost) || event.cancelled">
                                <p v-if="event.cancelled" class="ma-0">Sold<br>out</p>
                                <p class="ma-0" v-else-if="spotsLeft > 0">Only <span
                                    style="font-size: 2.2em; font-weight: bolder;">{{ spotsLeft }}</span><br>spot<span
                                    v-if="spotsLeft !== 1">s</span> left</p>
                                <p v-else-if="spotsLeft <= 0" class="ma-0">Sold<br>out</p>
                            </div>
                            <div v-if="isHost && !event.cancelled" style="float: right;">
                                <v-tooltip bottom>
                                    <v-btn
                                        flat
                                        class="btn-flat-icon--dark mr-2 mt-2"
                                        @click="openEditModal"
                                        slot="activator"
                                        style="width: 50px!important; min-width: 50px!important; color: #AAA!important;"
                                    >
                                        <v-icon medium>fal fa-edit</v-icon>
                                    </v-btn>
                                    <span>Edit event</span>
                                </v-tooltip>
                            </div>
                            <v-card-text style="position: relative;">
                                <div class="event-page-details-table">
                                    <div class="event-page-details-flex mb-1">
                                        <div class="details-icon pa-1" style="width: 50px;">
                                            <i style="font-size: 1.5em;" class="success--text fal fa-map-marker"></i>
                                        </div>
                                        <div class="content">
                                            <p class="event-page-card-content ma-0">{{ locationShort }}</p>
                                        </div>
                                    </div>
                                    <div class="event-page-details-flex mb-1">
                                        <div class="details-icon pa-1" style="width: 50px;">
                                            <i style="font-size:1.5em;" class="link--text fal fa-clock"></i>
                                        </div>
                                        <div class="content">
                                            <p class="event-page-card-content ma-0">{{ eventTime }}</p>
                                        </div>
                                    </div>

                                    <div class="event-page-details-flex mb-1">
                                        <div class="details-icon pa-1" style="width: 50px;">
                                            <i style="font-size:1.5em;" class="link--text fal fa-clock"></i>
                                        </div>
                                        <div class="content">
                                            <p class="event-page-card-content ma-0">{{ weekday }}, {{ eventDateNumeric }}</p>
                                        </div>
                                    </div>

                                    <div class="event-page-details-flex mb-1">
                                        <div class="details-icon pa-1" style="width: 50px;">
                                            <i style="font-size:1.5em;" class="error--text fal fa-check-square"></i>
                                        </div>
                                        <div class="content">
                                            <p class="event-page-card-content ma-0">
                                                <span>Open to&nbsp;</span>
                                                <span v-for="(r,index) in event.restrictions.provisions" :key="r">
													<span v-if="r === 'occupation_or_interest'">
														people interested in {{
                                                            event.restrictions.inputs[r + '_input']
                                                        }}<span v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
													</span>
													<span v-else-if="r === 'women_only'">
														women only<span
                                                        v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
													</span>
													<span v-else-if="r === 'parents_only'">
														parents with children {{
                                                            event.restrictions.inputs.min_child_age
                                                        }} to {{ event.restrictions.inputs.max_child_age }}<span
                                                        v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
													</span>
													<span v-else-if="r === 'age_range'">
														people between the ages of {{
                                                            event.restrictions.inputs.min_age
                                                        }} to {{ event.restrictions.inputs.max_age }}<span
                                                        v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span>
													</span>
													<span v-else>{{ r }}<span
                                                        v-if="index < event.restrictions.provisions.length - 1">,&nbsp;</span></span>
												</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="event-page-details-flex mb-1" v-if="eventAmenities.length !== 0">
                                        <div class="details-icon pa-1" style="width: 50px;">
                                            <i style="font-size:1.5em;" class="fal fa-coffee"></i>
                                        </div>
                                        <div class="content">
                                            <p class="event-page-card-content ma-0">
												<span
                                                    v-if="event.provisions.hasOwnProperty('amenitiesInputs') && event.provisions.amenitiesInputs.hasOwnProperty('other_snack_input')"
                                                    style="text-transform: capitalize;"
                                                >
													{{ event.provisions.amenitiesInputs.other_snack_input }}, 
												</span>
                                                <span v-for="(p, index) in eventAmenities"
                                                      style="text-transform: capitalize;" :key="index">
													{{ p }}<span v-if="index == eventAmenities.length - 2"> &amp;</span><span
                                                    v-else-if="index < eventAmenities.length -1">,</span>
												</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="event-page__card-divider mt-4 mb-3"></div>
                                <div class="event-page__smaller-text-on-xl">
                                    <div v-if="isAttending && event.cancelled"
                                         class="event-page__card-alert-bar error white--text text-xs-center mt-2 mb-2">
                                        This&nbsp;<span style="text-transform: uppercase">{{ event.category }}</span>&nbsp;has
                                        been cancelled.
                                    </div>
                                    <div v-else-if="isHost"
                                         class="event-page__card-alert-bar success white--text text-xs-center mt-2 mb-2">
                                        You're hosting this&nbsp;<span
                                        style="text-transform: uppercase">{{ event.category }}!</span></div>
                                    <div v-else-if="isAttending"
                                         class="event-page__card-alert-bar success white--text text-xs-center mt-2 mb-2">
                                        You're registered for this&nbsp;<span
                                        style="text-transform: uppercase">{{ event.category }}!</span></div>
                                </div>

                                <!-- <div v-if="isAttending">
                                    <v-btn block class="info" @click="goToActive()">Active Event Page</v-btn>
                                </div> -->

                                <div v-if="!isAttending && !getApprovalStatus">
                                    <v-layout column align-center justify-center>
                                        <p class="event-page-content-light mb-3">Price per person for:</p>
                                        <p class="event-page-card-category ma-0">
                                            {{ event.category }}
                                        </p>
                                        <p class="event-page-card-location ma-0">
                                            <span style="font-size: .75em">@</span>
                                            {{ event.location.name }}
                                        </p>
                                        <div class="event-page-card-price text-xs-center mt-2 mb-3">
                                            <span v-if="getPrice == 0 && freePass"
                                                  style="font-size: 2.0em; margin-bottom:10px; margin-top: 30px!important; line-height: 20px;">FREE<br><span
                                                style="font-size: 0.3em;"><i>You get a free pass for being a member!</i></span></span>
                                            <span v-else-if="getPrice > 0">$<span style="font-size: 2.0em;">{{
                                                    getPrice
                                                }}</span></span>
                                            <span v-else style="font-size: 2.0em;">FREE</span>
                                        </div>
                                    </v-layout>
                                    <div style="position: relative" class="pb-3"
                                         v-if="event.addons.length !== 0 && event.addons !== null && event.addons !== ''">
                                        <div v-if="event.addons[0]">
                                            <v-checkbox v-model="buyAddon" hide-details></v-checkbox>
                                            <p @click="buyAddon = !buyAddon" class="event-page-content-light-2"
                                               style="position: absolute; top: 6px; left: 30px; cursor: pointer;">
                                                Include ${{ event.addons[0].price }} {{ event.addons[0].title }}
                                                add-on</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="isHost">
                                    <p class="text-xs-center event-page__going error--text mb-1">Attendees</p>
                                    <p class="text-xs-center mb-1"
                                       style="font-size: 1.1em; font-weight: bold; font-family: 'Quantico'; color: #666">
                                        {{ event.attendees.length }}&nbsp;/&nbsp;{{ event.max_attendees }}</p>
                                    <v-list>
                                        <v-list-tile avatar v-for="attendee in event.attendees.slice(0,20)"
                                                     :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
                                            <v-list-tile-avatar>
                                                <img :src="attendee.avatar + '?w=50'">
                                            </v-list-tile-avatar>
                                            <v-list-tile-content
                                                style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                                <v-list-tile-title
                                                    v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
                                                <v-tooltip top v-if="userInAddon(attendee.pk)">
                                                    <v-icon small slot="activator">fal fa-star</v-icon>
                                                    <span>Attending {{ event.addons[0].title }}</span>
                                                </v-tooltip>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                    <v-btn flat class="info" block v-if="event.attendees.length > 20"
                                           @click="attendeesModal=true">See all
                                    </v-btn>
                                    <v-btn block class="info" @click="messageAllGuestsModal=true">Message all guests
                                    </v-btn>
                                    <div v-if="event.pending_attendees.length > 0">
                                        <h4 class="text-xs-center error--text">Pending attendees</h4>
                                        <v-list>
                                            <v-list-tile avatar v-for="attendee in event.pending_attendees"
                                                         :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
                                                <v-list-tile-avatar>
                                                    <img :src="attendee.avatar + '?w=50'">
                                                </v-list-tile-avatar>
                                                <v-list-tile-content
                                                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                                    <div
                                                        style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline">
                                                        <v-tooltip top>
                                                            <v-btn icon slot="activator"
                                                                   @click.stop="approveGuest(attendee.uuid)"
                                                                   class="ma-0">
                                                                <v-icon color="success">fal fa-plus-circle</v-icon>
                                                            </v-btn>
                                                            <span>Approve</span>
                                                        </v-tooltip>
                                                        <v-tooltip top>
                                                            <v-btn icon slot="activator"
                                                                   @click.stop="denyGuest(attendee.uuid)" class="ma-0">
                                                                <v-icon color="error">fal fa-minus-circle</v-icon>
                                                            </v-btn>
                                                            <span>Deny</span>
                                                        </v-tooltip>
                                                    </div>
                                                    <v-list-tile-title
                                                        v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
                                                    <v-tooltip top v-if="userInAddon(attendee.pk)">
                                                        <v-icon small slot="activator" class="ma-0">fal fa-star</v-icon>
                                                        <span>Attending {{ event.addons[0].title }}</span>
                                                    </v-tooltip>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </div>
                                    <div v-if="event.denied_attendees.length > 0">
                                        <h4 class="text-xs-center error--text">Denied Attendees</h4>
                                        <v-list>
                                            <v-list-tile avatar v-for="attendee in event.denied_attendees"
                                                         :key="attendee.uuid" @click="openGuestModal(attendee.uuid)">
                                                <v-list-tile-avatar>
                                                    <img :src="attendee.avatar + '?w=50'">
                                                </v-list-tile-avatar>
                                                <v-list-tile-content
                                                    style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                                                    <div
                                                        style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline">
                                                        <v-tooltip top>
                                                            <v-btn icon slot="activator"
                                                                   @click.stop="approveGuest(attendee.uuid)"
                                                                   class="ma-0">
                                                                <v-icon color="success">fal fa-plus-circle</v-icon>
                                                            </v-btn>
                                                            <span>Switch to approved</span>
                                                        </v-tooltip>
                                                    </div>
                                                    <v-list-tile-title
                                                        v-text="attendee.first_name + ' ' + attendee.last_name"></v-list-tile-title>
                                                    <v-tooltip top v-if="userInAddon(attendee.pk)">
                                                        <v-icon small slot="activator" class="ma-0">fal fa-star</v-icon>
                                                        <span>Attending {{ event.addons[0].title }}</span>
                                                    </v-tooltip>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-list>
                                    </div>
                                </div>
                                <div v-else-if="!getApprovalStatus" class="text-xs-center"
                                     :style="{'height': isAttending ? '55px' : '0px'}">
                                    <!-- <div class="rsvp-mobile-bottom-nav__calendar" style="pointer-events: none; z-index: 2;">
                                        <v-layout column align-center justify-center style="height: 100%; width: 100%">
                                            <i class="fal fa-calendar-plus" style="margin-bottom: -3px; font-size: 2.0em; color: #555;"></i>
                                            <p class="mb-0">Add to calendar</p>
                                        </v-layout>
                                    </div>
                                    <add-to-calendar
                                        class="rsvp-mobile-bottom-nav__calendar"
                                        v-if="event.approved"
                                        height="55px"
                                        width="50%"
                                        :title="event.title"
                                        :date="event.date"
                                        :startTime="event.time_start"
                                        :endTime="event.time_end"
                                        :description="event.description"
                                        :location="getLocationAddress"
                                    ></add-to-calendar> -->
                                    <div class="event-page__smaller-text-on-xl"
                                         style="height: 65px; position: absolute; bottom: 0; left: 0; display: flex; flex-direction: row; justify-content: space-between; width: 100%">
                                        <a
                                            class="rsvp-card__directions link-button"
                                            :href="'https://www.google.com/maps/dir/?api=1&destination=' + getCoords"
                                            target="_blank"
                                            style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                                            :disabled="event.cancelled"
                                            @click="clickDirections"
                                        >
                                            <i class="mt-2 fas fa-location-arrow"
                                               style="font-size: 2.0em; color: #555; height: 33px;"></i>
                                            <span class="mb-2" style="font-size: 0.9em; color: #555;">Directions</span>
                                        </a>
                                        <button
                                            type="button"
                                            class="rsvp-card__calendar"
                                            @click="openCalendarModal"
                                            style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                                            :disabled="event.cancelled"
                                        >
                                            <i class="mt-2 fas fa-calendar-plus"
                                               style="font-size: 2.0em; color: #555; height: 33px;"></i>
                                            <span class="mb-2" style="font-size: 0.9em;">Add to calendar</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="info rsvp-card__invite-friends"
                                            @click="shareModalOpen=true"
                                            style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                                            :disabled="event.cancelled"
                                        >
                                            <i class="mt-2 fas fa-user-plus"
                                               style="font-size: 2.0em; height: 33px;"></i>
                                            <span class="mb-2" style="font-size: 0.9em;">Invite a friend!</span>
                                        </button>
                                    </div>
                                </div>
                                <div v-else-if="getApprovalStatus">
                                    <h4 class="red--text text-xs-center mb-2">{{ getApprovalStatus }}</h4>
                                </div>
                                <div v-if="getEventTimeLeft === true">
                                    <v-btn
                                        dark
                                        block
                                        v-if="event.approved && !isHost && !isAttending && !getApprovalStatus && (this.event.attendees.length < this.event.max_attendees)"
                                        class="btn-orange event-page__rsvp-button"
                                        @click="openRsvp"
                                        :disabled="disableButton || (this.event.attendees.length >= this.event.max_attendees) || event.cancelled"
                                    >
                                        RSVP
                                    </v-btn>
                                </div>
                                <div v-else class="text-xs-center red--text pt-3 pb-3">
                                    <h3>
                                        {{ getEventTimeLeft }}
                                    </h3>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <div v-if="!isHost && !isAttending" class="rsvp-mobile-bottom-nav pa-0 hidden-md-and-up">
			<span class="rsvp-mobile-bottom-nav__sticky-note text-xs-center"
                  v-if="(showSpotsLeft && !isAttending) || event.cancelled">
				<p v-if="event.cancelled" class="ma-0">Sold<br>Out</p>
				<p class="ma-0" v-else-if="spotsLeft > 0">Only <span
                    style="font-size: 2.2em; font-weight: bolder;">{{ spotsLeft }}</span><br>spot<span
                    v-if="spotsLeft !== 1">s</span> left</p>
				<p v-else-if="spotsLeft <= 0" class="ma-0">Sold<br>Out</p>
			</span>

            <div class="rsvp-mobile-bottom-name__left-col">
                <div
                    v-if="getPrice > 0"
                    class="ma-0 mt-2 rsvp-mobile-bottom-nav__price text-xs-center"
                >
                    <span style="font-family: 'Permanent Marker', cursive;" class="mb-0">$</span>
                    <span style="font-size: 1.7em;">{{ getPrice }}</span>
                </div>
                <div
                    v-else
                    class="mt-2 text-xs-center"
                    style="font-size: 1.7em;"
                >
                    FREE
                </div>
            </div>

            <span class="ma-0 rsvp-mobile-bottom-nav__date-time text-xs-center">
				<span
                    style="font-size:0.7em;">{{ convertTime(event.time_start) }}&nbsp;-&nbsp;{{
                        eventMonth
                    }}&nbsp;{{ eventDay }}</span>
			</span>
            <div class="rsvp-mobile-bottom-nav__checkout">
                <v-btn
                    block
                    flat
                    large
                    class="btn-orange ma-0"
                    :style="disabledButtonStyle"
                    @click="openRsvp"
                    :disabled="disableButton || (event.attendees.length >= event.max_attendees) || !(event.approved) || event.cancelled">
                    RSVP
                </v-btn>
            </div>
        </div>
        <div v-else-if="isHost" class="rsvp-mobile-bottom-nav ma-0 pa-0 hidden-md-and-up">
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="openCalendarModal"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
            >
                <i class="mt-3 fas fa-calendar-plus" style="font-size: 2.0em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Add to calendar</span>
            </button>
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="shareModalOpen=true"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
            >
                <i class="mt-3 fas fa-user-plus" style="font-size: 2.0em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Invite a friend!</span>
            </button>
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="attendeesModal=true"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
            >
                <i :class="{'fas': true, 'fa-users': true, 'badge': event.pending_attendees.length > 0}"
                   style="margin-top: 13px; margin-bottom: 3px; font-size: 2.4em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Attendees</span>
            </button>
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="openEditModal"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
            >
                <i class="fas fa-edit"
                   style="margin-top: 13px; margin-bottom: 3px; font-size: 2.2em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Edit event</span>
            </button>
        </div>
        <div v-else-if="isAttending" class="rsvp-mobile-bottom-nav ma-0 pa-0 hidden-md-and-up">
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="openCalendarModal"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
            >
                <i class="mt-3 fas fa-calendar-plus" style="font-size: 2.0em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Add to calendar</span>
            </button>
            <button
                type="button"
                class="rsvp-mobile-bottom-nav__calendar text"
                @click="shareModalOpen=true"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
            >
                <i class="mt-3 fas fa-user-plus" style="font-size: 2.0em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Invite a friend!</span>
            </button>
            <a
                class="rsvp-mobile-bottom-nav__calendar text link-button"
                :href="'https://www.google.com/maps/dir/?api=1&destination=' + getCoords"
                style="height: 100%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
                :disabled="event.cancelled"
                @click="clickDirections"
            >
                <i class="mt-3 fas fa-location-arrow" style="font-size: 2.0em; height: 33px;"></i>
                <span class="mb-3" style="font-size: 0.75em;">Directions</span>
            </a>
        </div>
        <div v-if="isAttending && event.cancelled"
             class="event-page__top-alert-bar error hidden-md-and-up white--text text-xs-center ma-0 pa-0">
            This&nbsp;<span style="text-transform: uppercase">{{ event.category }}</span>&nbsp;has been cancelled.
        </div>
        <div v-else-if="isHost"
             class="event-page__top-alert-bar success hidden-md-and-up white--text text-xs-center ma-0 pa-0">You're
            Hosting this&nbsp;<span style="text-transform: uppercase">{{ event.category }}!</span></div>
        <div v-else-if="isAttending"
             class="event-page__top-alert-bar success hidden-md-and-up white--text text-xs-center ma-0 pa-0"><strong>You
            are registered for this&nbsp;<span style="text-transform: uppercase">{{ event.category }}!</span></strong>
        </div>
    </div>
</template>

<script>
import {Item} from 'vue-lory'
import Lory from '~/components/LoryCarousel.vue'

import {mapActions, mapGetters} from 'vuex'

import AddToCalendar from '~/components/AddToCalendar.vue'
import GoogleMap from '~/components/GoogleMap'
import ChoiceFieldDisplay from '~/components/ChoiceFieldDisplay'

import {
    locationInfoOptions,
    eventProvisionsOptions,
    eventRestrictionOptions
} from '~/store/util/values'
import {fetchEventBySlug, fetchLocation, fetchAllEvents} from '~/store/api/event_location_api'
import store from '~/store'
import {fetchUser} from '~/store/api/user'

import {replaceNewlines} from '~/store/util/util'
import btDropin from 'braintree-web-drop-in'
import axios from 'axios'

import {parse, format, differenceInHours} from 'date-fns'
import Vue from 'vue'

import lory from 'lory.js'

export default {
    data() {
        return {
            event: {},
            buyAddon: false,
            disableButton: false,
            inviteFriendEmail: null,
            eventURL: window.location.href,
            openHostModal: false,
            previousPage: null,
            currentTab: null,
            userAttending: false,
            guestModalIndex: 0,
            cohostModalIndex: 0,
            mapzoom: 15,
            locationInfoOptions: locationInfoOptions,
            eventProvisionsOptions: eventProvisionsOptions,
            eventRestrictionOptions: eventRestrictionOptions,
            // contact host form
            name: '',
            email: '',
            phone: '',
            city: '',
            contactHostMessage: '',
            reportEventMessage: '',
            contactGuestMessage: '',
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 20 || 'Name must be less than 20 characters'
            ],
            emailRules: [
                v => !!v || 'E-mail is required',
                v =>
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
                    'E-mail must be valid'
            ],
            phoneRules: [
                v =>
                    /(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
                    'Please enter a valid phone number'
            ],
            cityRules: [
                v => v.length <= 20 || 'City must be less than 20 characters'
            ],
            // paymentToken: null,
            // dropinOptions: {
            // 	authorization: null,
            // 	selector: '#dropin-container',
            // },
            // errorMessage: '',
            // dropinInstance: '',
            // paymentPayload: '',
            // dataCollectorPayload: '',
            // wrapperClass: 'constrain',
            // collectCardHolderName: true,
            // enableDataCollector: true,
            // enablePayPal: true,
            // paymentMethodNonce: null,
            // startingPremium: false,
            submitStarted: false
            // loadingBraintree: true,
        }
    },
    beforeRouteEnter(to, from, next) {
        console.log(to.params.slug)
        fetchEventBySlug(to.params.slug).then((response) => {
            console.log('response', response.data)
            next(vm => {
                vm.setEvent(response.data)
                if (from.name !== 'host_add_event_submit') {
                    vm.previousPage = from
                } else {
                    vm.previousPage = {
                        path: '/host/dashboard'
                    }
                }
            })
        }).catch((error) => {
            console.error(error)
            next({path: '/'})
        })
    },
    created() {
        console.log('created')
        this.name = this.user.first_name + ' ' + this.user.last_name
        this.email = this.user.email
    },
    mounted() {
        console.log('mounted')
        if (this.$route.query.hasOwnProperty('addonUpsell')) {
            let slug = this.$route.params.slug
            if (!this.userInAddon(this.user.pk)) {
                this.setModalOpen({prop: 'addonUpsellModal', value: true})
                this.setPaymentModalEvent(this.event)
            }
        }
    },
    methods: {
        ...mapActions([
            'favoriteEvent',
            'eventRSVP',
            'setEventProp',
            'setCurrentEvent',
            'setPaymentModalEvent',
            'setMembershipUpsellModalEvent',
            'setSnackbarOpen',
            'setSnackbarText',
            'setModalOpen',
            'setModalProp',
            'setShareModalEvent',
            'setGenericModalTitle',
            'setGenericModalText',
            'setEventRSVPSuccessModalEvent',
            'setCalendarModalEvent',
            'setEditEventContactFormEvent'
        ]),
        setEvent(event) {
            this.event = event
            this.setCurrentEvent(event)
        },
        approveGuest(guestUUID) {
            axios
                .get(
                    '/api/v1/event/' +
                    this.event.slug +
                    '/approve-guest/' +
                    guestUUID +
                    '/'
                )
                .then(response => {
                    console.log(response)
                    let userObj =
                        this.event.pending_attendees.find(obj => obj.uuid === guestUUID) ||
                        this.event.denied_attendees.find(obj => obj.uuid === guestUUID)
                    let newArray
                    // Alter the originating array of users to remove the user
                    if (this.event.pending_attendees.indexOf(userObj) > -1) {
                        // If the user was in the pending_attendees list
                        newArray = this.event.pending_attendees.slice(0)
                        newArray.splice(this.event.pending_attendees.indexOf(userObj), 1)
                        this.event.pending_attendees = newArray
                    } else if (this.event.denied_attendees.indexOf(userObj) > -1) {
                        // If the user was in the denied_attendees list
                        newArray = this.event.denied_attendees.slice(0)
                        newArray.splice(this.event.denied_attendees.indexOf(userObj), 1)
                        this.event.denied_attendees = newArray
                    } else {
                        console.log(
                            'User object not found in pending attendees or denied attendees'
                        )
                    }
                    this.event.attendees = this.event.attendees.concat(userObj)
                    this.setEventProp({
                        prop: 'attendees',
                        value: this.event.attendees.concat(userObj)
                    })
                })
                .catch(error => {
                    console.error(error)
                })
        },
        denyGuest(guestUUID) {
            this.setModalProp({prop: 'eventModalEvent', value: this.event})
            this.setModalProp({prop: 'eventGuestModalIndex', value: guestUUID})
            this.setModalOpen({prop: 'denyGuestConfirmationModal', value: true})
        },
        userInAddon(pk) {
            if (this.event.addons.length > 0) {
                if (this.event.addons[0].attendees) {
                    if (this.event.addons[0].attendees.includes(pk)) {
                        return true
                    }
                }
            }
            return false
        },
        inviteFriend() {
            axios
                .post('/api/v1/contact/', {
                    name: this.user.first_name + ' ' + this.user.last_name,
                    subject: 'Invite Friend to wrkprty',
                    event: this.event.pk,
                    message:
                        'Send invite to ' +
                        this.inviteFriendEmail +
                        ' on behalf of ' +
                        this.user.first_name +
                        ' ' +
                        this.user.last_name,
                    email: this.user.email
                })
                .then(response => {
                    this.inviteFriendEmail = ''
                    this.setSnackbarText('Invite Sent! Try sending another!')
                    this.setSnackbarOpen(true)
                })
        },
        copyEventLink() {
            this.$refs.eventUrlInput.select()
            try {
                var successful = document.execCommand('copy')
                var msg = successful ? 'successful' : 'unsuccessful'
                console.log('Copying text command ' + msg)
            } catch (err) {
                console.log('Oops, unable to copy')
            }
        },
        resetContactModal() {
            this.contactGuestModal = false
            this.reportEventModal = false
            this.contactHostModal = false
            this.reportEventMessage = ''
            this.contactHostMessage = ''
            this.contactGuestMessage = ''
        },
        goBack() {
            if (this.previousPage === null) {
                this.$router.push('/')
            } else {
                this.$router.push(this.previousPage.path)
            }
        },
        onClickRSVP() {
            this.eventRSVP({user_pk: this.user.pk, pk: this.event.pk})
        },
        convertTime(time) {
            let timeArray = time.split(':')
            let timeString = ''
            let stringEnd = ''
            if (parseInt(timeArray[0]) < 12) {
                timeString += String(parseInt(timeArray[0]))
                stringEnd = 'am'
            } else if (parseInt(timeArray[0]) === 12) {
                timeString += String(parseInt(timeArray[0]))
                stringEnd = 'pm'
            } else {
                timeString += String(parseInt(timeArray[0]) - 12)
                stringEnd = 'pm'
            }
            if (parseInt(timeArray[1]) !== 0) {
                timeString += ':' + String(parseInt(timeArray[1]))
            }
            timeString += '' + stringEnd
            return timeString
        },
        newlines(value) {
            return replaceNewlines(value)
        },
        openRsvp() {
            if (this.getPrice === 0.0) {
                this.disableButton = true
                axios.post('/api/v1/event/rsvp/', {
                    buy_addon: this.buyAddon,
                    event_id: this.event.pk,
                    payment_method_nonce: null,
                    starting_premium: null
                }).then((response) => {
                    this.event.attendees = response.data.event.attendees
                    this.event.pending_attendees = response.data.event.pending_attendees
                    this.event.location = response.data.event.location

                    this.setModalOpen({prop: 'eventRSVPSuccessModal', value: true})
                    this.setEventRSVPSuccessModalEvent(this.event)
                    if (this.buyAddon) {
                        let addonObjArray = [
                            {
                                price: this.event.addons[0].price,
                                title: this.event.addons[0].title
                            }
                        ]
                        this.setModalProp({
                            prop: 'eventRSVPSuccessModalAddons',
                            value: addonObjArray
                        })
                    }
                }).catch(error => {
                    this.disableButton = false
                    this.setModalOpen({prop: 'genericModal', value: true})
                    this.setGenericModalTitle('Error')
                    this.setGenericModalText([
                        'Payment failed, please refresh page and try again'
                    ])
                    console.log(error)
                    console.log(error.response)
                })
            } else {
                // let hostGroups = this.event.host.user.groups
                // for (var i = 0; i < hostGroups.length; i++) {
                // 	if (hostGroups[i].name === 'host-no-membership') {
                // 		this.setModalOpen({prop: 'paymentModal', value: true})
                // 		this.setPaymentModalEvent(this.event)
                // 		i = hostGroups.length
                // 	} else if (hostGroups[i].name === 'host-membership') {
                // 		this.setModalOpen({prop: 'membershipUpsellModal', value: true})
                // 		this.setMembershipUpsellModalEvent(this.event)
                // 		i = hostGroups.length
                // 	}
                // }
                // console.log('no group')
                this.setModalOpen({prop: 'paymentModal', value: true})
                this.setPaymentModalEvent(this.event)
                if (this.buyAddon) {
                    let addonObjArray = [
                        {
                            price: this.event.addons[0].price,
                            title: this.event.addons[0].title
                        }
                    ]
                    this.setModalProp({
                        prop: 'paymentModalAddons',
                        value: addonObjArray
                    })
                }
            }
        },
        openCalendarModal() {
            this.setCalendarModalEvent(this.event)
            this.setModalOpen({prop: 'calendarModal', value: true})
        },
        openEditModal() {
            this.setModalOpen({prop: 'editEventContactForm', value: true})
            this.setEditEventContactFormEvent(this.event)
        },
        backgroundImageStyle(image) {
            let style = {
                'background-image': 'url(' + image + ')',
                'background-position': 'center',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                height: '100%'
            }
            return style
        },
        openGuestModal(index) {
            this.guestModal = true
            this.setModalProp({prop: 'eventGuestModalIndex', value: index})
        },
        openCohostModal(index) {
            this.cohostModal = true
            this.setModalProp({prop: 'eventCohostModalIndex', value: index})
        },
        clickDirections() {
        }
    },
    watch: {
        currentTab() {
            // Call resizePreserveCenter() on all maps
            Vue.$gmapDefaultResizeBus.$emit('resize')
        }
    },
    computed: {
        ...mapGetters([
            'user',
            'getCurrentEvent',
            'getModalProp'
        ]),
        messageAllGuestsModal: {
            get() {
                return this.getModalProp('eventContactAllGuestsModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventContactAllGuestsModal', value: val})
            }
        },
        requiresApproval() {
            if (this.event.restrictions.approval === 'all_need_approval') {
                return true
            }
            if (this.event.restrictions.approval === 'level_one') {
                if (this.user.past_events) {
                    if (this.user.past_events.length === 0) {
                        return true
                    }
                }
            }
        },
        getApprovalStatus() {
            if (this.event.pending_attendees.includes(this.user.uuid)) {
                return 'Your request is pending. You should hear back from the host shortly.'
            }
            if (this.event.denied_attendees.includes(this.user.uuid)) {
                return 'Your request to join this event has been denied'
            }
        },
        getPrice() {
            let price = 0.0
            if (this.event) {
                if (
                    this.event.addons.length > 0 &&
                    this.event.addons !== null &&
                    this.event.addons !== ''
                ) {
                    if (this.event.addons[0]) {
                        if (this.event.addons[0].approved) {
                            if (this.buyAddon) {
                                price += parseFloat(this.event.addons[0].price)
                            }
                        }
                    }
                }
                if (!this.freePass) {
                    price += this.event.price
                }
            }
            return price
        },
        getEventTimeLeft() {
            let eventEnd = parse(this.event.date + ' ' + this.event.time_end)//, 'yyyy-MM-dd HH:mm:ss', new Date(2018, 12, 0, 0, 0, 0))
            console.log(eventEnd)
            var timeLeft = differenceInHours(eventEnd, new Date())
            console.log(timeLeft)
            if (timeLeft > 1) {
                return true
            } else if (timeLeft < 0) {
                return 'The event is over'
            } else {
                return 'The event is almost over'
            }
        },
        shareModalOpen: {
            get() {
                return this.getModalProp('shareModal')
            },
            set(val) {
                this.setShareModalEvent(this.event)
                this.setModalOpen({prop: 'shareModal', value: val})
            }
        },
        eventAmenities() {
            let result = []
            if (this.event.hasOwnProperty('provisions')) {
                if (this.event.provisions.hasOwnProperty('amenities')) {
                    result = this.event.provisions.amenities.filter(a => {
                        return ['coffee', 'tea', 'soda', 'water', 'fruit'].indexOf(a) > -1
                    })
                }
            }
            return result
        },
        likedEvent() {
            if (this.user.liked_events.indexOf(this.event.pk) > -1) {
                return 'fas fa-heart'
            }
            return 'fal fa-heart'
        },
        eventCategoryLongDescription() {
            if (this.event.what_to_expect !== '') {
                return this.event.what_to_expect
            } else if (this.event.category === 'wrkprty') {
                return 'Experience the best workday at the WRKPRTY original curated <strong>coworking event</strong> where attendees work side-by-side for increased productivity and connection. Each WRKPRTY is a unique blend of location, the host, and guests, but the format and structure help ensure productivity goals are met, and that everyone has a chance to meet and connect.'
            }
            // else if (this.event.category === 'wrkshop') {
            // 	return 'This is a work shop where you learn. Where attendees work side-by-side for increased productivity and connection. Each WRKPRTY is a unique blend of location, the host, and guests, but the format and structure help ensure productivity goals are met, and that everyone has a chance to meet and connect.'
            // }
            return ''
        },
        formattedTime() {
            if (event) {
                let start = this.timeToAMPM(this.event.time_start)
                let end = this.timeToAMPM(this.event.time_end)

                if (!start || !end) {
                    return ''
                }

                let startSuffix = ''
                let endSuffix = ''

                if (start.includes('a')) {
                    startSuffix = 'a'
                } else {
                    startSuffix = 'p'
                }

                if (end.includes('a')) {
                    endSuffix = 'a'
                } else {
                    endSuffix = 'p'
                }

                return (
                    start.split(':')[0] +
                    startSuffix +
                    ' - ' +
                    end.split(':')[0] +
                    endSuffix
                )
            }
            return ''
        },
        eventTime() {
            let timeStart = this.event.time_start
            let timeEnd = this.event.time_end
            return this.convertTime(timeStart) + ' - ' + this.convertTime(timeEnd)
        },
        eventDateNumeric() {
            return format(this.eventDate, 'MM/DD')
        },
        eventDate() {
            return parse(this.event.date) //, 'yyyy-MM-dd', new Date())
        },
        eventMonth() {
            return format(this.eventDate, 'MMM')
        },
        eventDay() {
            return format(this.eventDate, 'Do')
        },
        isHost() {
            if (this.user.pk === this.event.host.user.pk) {
                return true
            } else if (
                this.event.cohosts.find(obj => obj.user.pk === this.user.pk)
            ) {
                return true
            } else {
                return false
            }
        },
        location() {
            if (this.event.hasOwnProperty('location')) {
                return this.event.location
            } else {
                return {}
            }
        },
        host() {
            return this.event.host.user
        },
        isAttending() {
            let attending = false
            if (this.isHost) {
                attending = true
            } else {
                if (this.getCurrentEvent) {
                    if (this.getCurrentEvent.hasOwnProperty('attendees')) {
                        attending = this.getCurrentEvent.attendees.indexOf(this.user.uuid) > -1
                        if (!attending) {
                            attending = this.getCurrentEvent.attendees.find(obj => {
                                return obj.uuid === this.user.uuid
                            })
                            if (attending === undefined) {
                                attending = false
                            }
                        }
                    }
                }
            }
            return attending
        },
        weekday() {
            return format(this.eventDate, 'ddd')
        },
        timeToAMPM() {
            return timeString => {
                let time = timeString
                    .toString()
                    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [timeString]
                if (time.length > 1) {
                    time = time.slice(1)
                    if (time.length > 3) {
                        time.pop()
                    }
                    time[5] = +time[0] < 12 ? 'am' : 'pm'
                    time[0] = +time[0] % 12 || 12
                }
                return time.join('')
            }
        },
        locationShort() {
            let locationString = ''
            if (this.location.hasOwnProperty('address')) {
                let addressComponents = []
                if (this.isAttending || this.isHost) {
                    if (this.location.address.hasOwnProperty('street_number')) {
                        if (this.location.address.hasOwnProperty('route')) {
                            addressComponents.push(
                                this.location.address.street_number +
                                ' ' +
                                this.location.address.route
                            )
                        }
                    }
                } else {
                    if (this.location.address.hasOwnProperty('neighborhood')) {
                        if (this.location.address.neighborhood !== '') {
                            addressComponents.push(this.location.address.neighborhood)
                        }
                    }
                }
                if (this.location.address.hasOwnProperty('city')) {
                    addressComponents.push(this.location.address.city)
                }
                if (this.location.address.hasOwnProperty('country')) {
                    if (this.location.address.country !== 'United States') {
                        addressComponents.push(this.location.address.country)
                    }
                }
                for (var i = 0; i < addressComponents.length; i++) {
                    locationString += addressComponents[i]
                    if (i < addressComponents.length - 1) {
                        locationString += ', '
                    }
                }
            }
            return locationString
        },
        mapcenter() {
            return {
                lat: parseFloat(
                    this.location.address.private_latitude ||
                    this.location.address.public_latitude
                ),
                lng: parseFloat(
                    this.location.address.private_longitude ||
                    this.location.address.public_longitude
                )
            }
        },
        editEventRoute() {
            return '/host/edit/event/' + this.event.pk + '/'
        },
        mapSizeOuter() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '110px'
                case 'sm':
                    return '120px'
                case 'md':
                    return '120px'
                case 'lg':
                    return '120px'
                case 'xl':
                    return '140px'
            }
        },
        mapSizeInner() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '100px'
                case 'sm':
                    return '110px'
                case 'md':
                    return '110px'
                case 'lg':
                    return '110px'
                case 'xl':
                    return '130px'
            }
        },
        test() {
            let images = this.event.additional_images
            let style = {
                'background-image': 'url(' + images[0].image + ')',
                // 'background-position': 'center',
                'background-size': 'cover',
                'background-repeat': 'no-repeat'
            }
            // console.log(style)
            return style
        },
        getImages() {
            let images = [].concat(this.event.primary_image)
            images = images.concat(this.event.additional_images)
            if (this.event.location) {
                for (var i = images.length - 1; i >= 0; i--) {
                    if (images[i].pk === this.event.location.primary_image.pk) {
                        images.splice(i, 1)
                    } else if (
                        this.event.location.additional_images.find(obj => {
                            return obj.pk === images[i].pk
                        })
                    ) {
                        images.splice(i, 1)
                    }
                }
                images = images.concat(this.event.location.primary_image)
                images = images.concat(this.event.location.additional_images)
            }
            return images
        },
        showSpotsLeft() {
            return this.spotsLeft / this.event.max_attendees < 0.25
        },
        spotsLeft() {
            return this.event.max_attendees - this.event.attendees.length
        },
        getDuration() {
            let start =
                parseFloat(this.event.time_start.split(':')[0]) +
                parseFloat(this.event.time_start.split(':')[1]) / 60.0
            let end =
                parseFloat(this.event.time_end.split(':')[0]) +
                parseFloat(this.event.time_end.split(':')[1]) / 60.0
            let duration = end - start
            if (duration.toFixed(0) - duration === 0) {
                return duration.toFixed(0)
            } else {
                return duration.toFixed(2)
            }
        },
        disabledButtonStyle() {
            if (
                this.disableButton ||
                this.event.attendees.length >= this.event.max_attendees ||
                !this.event.approved
            ) {
                return {
                    'background-color': '#AAA!important'
                }
            }
        },
        getParkingInfo() {
            if (
                this.event.parking_info !== '' &&
                this.event.parking_info !== null
            ) {
                return this.event.parking_info
            } else if (
                this.event.location.parking_info !== '' &&
                this.event.location.parking_info !== null
            ) {
                return this.event.location.parking_info
            }
            return false
        },
        getCoords() {
            let lat = this.event.location.address.private_latitude
            let lon = this.event.location.address.private_longitude
            return lat + ',' + lon
        },
        freePass() {
            if (this.event) {
                if (this.user.free_pass) {
                    if (this.event.location.free_pass_allowed) {
                        return true
                    }
                }
            }
            return false
        },
        isMobile() {
            if (this.$vuetify.breakpoint.name === 'xs') {
                return true
            } else {
                return false
            }
        },
        hostModal: {
            get() {
                return this.getModalProp('eventHostModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventHostModal', value: val})
            }
        },
        attendeesModal: {
            get() {
                return this.getModalProp('eventAttendeesModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventAttendeesModal', value: val})
            }
        },
        locationModal: {
            get() {
                return this.getModalProp('eventLocationModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventLocationModal', value: val})
            }
        },
        guestRequirementsModal: {
            get() {
                return this.getModalProp('eventGuestRequirementsModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventGuestRequirementsModal', value: val})
            }
        },
        contactHostModal: {
            get() {
                return this.getModalProp('eventContactHostModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventContactHostModal', value: val})
            }
        },
        contactGuestModal: {
            get() {
                return this.getModalProp('eventContactGuestModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventContactGuestModal', value: val})
            }
        },
        reportEventModal: {
            get() {
                return this.getModalProp('eventReportEventModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventReportEventModal', value: val})
            }
        },
        cancellationPolicyModal: {
            get() {
                return this.getModalProp('eventCancellationPolicyModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventCancellationPolicyModal', value: val})
            }
        },
        guestModal: {
            get() {
                return this.getModalProp('eventGuestModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventGuestModal', value: val})
            }
        },
        cohostModal: {
            get() {
                return this.getModalProp('eventCohostModal')
            },
            set(val) {
                this.setModalProp({prop: 'eventModalEvent', value: this.event})
                this.setModalOpen({prop: 'eventCohostModal', value: val})
            }
        }
    },
    components: {
        GoogleMap,
        ChoiceFieldDisplay,
        AddToCalendar,
        Lory,
        Item
    }
}
</script>

<style lang="scss" scoped>
.carousel {
    .fade {
        &-enter-active,
        &-leave-active,
        &-leave-to {
            transition: 30s ease-out;
            position: absolute;
            top: 0;
            left: 0;
        }

        &-enter,
        &-leave,
        &-leave-to {
            opacity: 0;
        }
    }
}

.date-label {
    font-size: 1em;
}

.date-label-2 {
    font-size: 0.9em;
}

.card-background-image {
    background: #000000;
}

.card-background-image > div:nth-child(1) {
    opacity: 0.5;
}

.tabs-bar {
    background: rgba(0, 0, 0, 0.5);
}

.flex-container {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
}

.item-align-end {
    align-self: flex-end;

    display: flex;
    justify-content: flex-end;
}

.top-left-chip {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    margin: 25px 10px;
}

.bottom-left-buttons {
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: 0;
    margin: 0px 25px;
}


</style>
